import React from "react";
import RadarWidget from "./RadarWidget.js";
import WarningsWidget from "./WarningsWidget.js";

interface WidgetsSectionProps {
  className?: string;
}

const WidgetsSection: React.FC<WidgetsSectionProps> = ({ className }) => {
  return (
    <section className={`py-8 ${className || ""}`}>
      <div className="px-4 sm:px-8 lg:px-24">
        <div className="content-container">
          <div className="flex flex-col gap-6 lg:flex-row">
            <RadarWidget />
            <WarningsWidget />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WidgetsSection;
